import { useState } from 'react';

interface MobileStickyBarProps {
  onGetQuote: () => void;
}

export default function MobileStickyBar({ onGetQuote }: MobileStickyBarProps) {
  const handleWhatsApp = () => {
    window.open('https://wa.me/919711165605?text=Hi, I need a bulk quote for printer consumables', '_blank');
  };

  const handleCall = () => {
    window.location.href = 'tel:+919711165605';
  };

  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-2xl">
      <div className="grid grid-cols-3 divide-x divide-gray-200">
        <button
          onClick={handleCall}
          className="flex flex-col items-center justify-center py-3 hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
        >
          <i className="ri-phone-line text-2xl text-teal-700 mb-1"></i>
          <span className="text-xs font-medium text-gray-700">Call Now</span>
        </button>
        <button
          onClick={handleWhatsApp}
          className="flex flex-col items-center justify-center py-3 hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
        >
          <i className="ri-whatsapp-line text-2xl text-orange-500 mb-1"></i>
          <span className="text-xs font-medium text-gray-700">WhatsApp</span>
        </button>
        <button
          onClick={onGetQuote}
          className="flex flex-col items-center justify-center py-3 hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
        >
          <i className="ri-file-list-3-line text-2xl text-teal-700 mb-1"></i>
          <span className="text-xs font-medium text-gray-700">Get Quote</span>
        </button>
      </div>
    </div>
  );
}
